module.exports = __webpack_public_path__ + "static/footer.1ef25ef29301defc11f154817e8684bb.png";